import { Component, Prop, h } from '@stencil/core';
import { Labels, translate } from '../../../../utils/translations';
import { ActivityMapRegion, emitClickTrackerEvent } from '../../../../utils/utils';

export interface ShoppingCartConfig {
  enabled?: boolean;
  url?: string;
  externalLink?: boolean;
  isFull?: boolean;
  hasUnreadNotifications?: boolean;
}

@Component({
  tag: 'ds-header-shopping-cart',
  styleUrl: 'ds-header-shopping-cart.scss',
  shadow: true
})
export class HeaderShoppingCart {
  @Prop() url: string;
  @Prop() internalLink?: boolean = false;
  @Prop() isFull?: boolean;
  @Prop() hasUnreadNotifications?: boolean;
  @Prop() mobile?: boolean;

  render() {
    return (
      <ds-action-menu
        href={this.url}
        openInNewTab={!this.internalLink}
        openerLabel={translate(Labels.ShoppingCart)}
        onOpenerClick={() =>
          emitClickTrackerEvent({
            componentName: ActivityMapRegion.Header,
            title: `Open ${this.mobile ? 'Mobile ' : ''} Shopping Cart`,
            url: this.url
          })
        }
        mobile={this.mobile}
      >
        <div class='shopping-cart' slot='opener-content'>
          {this.hasUnreadNotifications && <ds-notification-dot />}
          <ds-icon
            name={this.isFull ? 'ShoppingCartFull' : 'ShoppingCart'}
            class='shopping-cart__icon'
            size='big'
          />
        </div>
      </ds-action-menu>
    );
  }
}
